// Used with elementIsRendered
function waitUntil (selector, scope, resolve, reject) {
    let loopCount = 0;
    let maxLoops = 100;
  
    // Loops until element exists in DOM or loop times out
    function checkForElement () {
      if (loopCount === maxLoops) {
        loopCount = 0;
        return reject('Timed out waiting for element to render');
     }
  
      let el = scope.querySelector(selector);
  
      setTimeout(() => {
        if (el) {
          loopCount = 0;
          return resolve(el);
        } else {
          loopCount++;
          checkForElement();
        }
      }, 100);
    }
  
    checkForElement()
}
  
// Returns a resolved Promise once the selector returns an element
// Useful for when we need to perform an action only when an element is in the DOM
export function elementIsRendered (selector, scope = document) {
    return new Promise((resolve, reject) => {
        //start the loop
        return waitUntil(selector, scope, resolve, reject);
    });
}